<template>
  <div>
    <van-nav-bar title="人员信息"
          left-arrow
      @click-left="onClickLeft"
    />
    <div style="background: #fff">
    <!-- <div class="ht15"></div> -->
    <!-- <div class="logo">
      <img src="../../assets/logo.png" class="logoimg">
    </div> -->
    </div>
    <div class="syBotsection mt4">
    <van-cell-group title="基本情况">
      <van-cell :value="userinfo.name" title="姓名" />
      <van-cell :value="userinfo.phone" type="tel" title="手机号" />
      <van-cell :value="userinfo.idCard" type="tel" title="身份证" />
    </van-cell-group>
     <van-cell-group title="地址">
      <van-cell :value="userinfo.ssq" title="省市区" />
      <!-- <van-cell :value="userinfo.city" title="市" />
      <van-cell :value="userinfo.district" title="区" /> -->
      <van-cell :value="userinfo.streetOfficeName" title="街道/乡镇" />
      <van-cell :value="userinfo.address" title="地址" clearable/>
     </van-cell-group>
     <van-cell-group title="年审情况">
      <van-cell title="救助类别">
          <template #default>
            <div v-for="item in userinfo.helpTypeName" :key="item" style="font-size: 12px">{{item}}</div>
          </template>
      </van-cell>
      <van-cell :value="userinfo.ads" title="年审状态">
        <template #default>
        <div>
          <div>{{userinfo.ads}}</div>
        </div>
        </template>
      </van-cell>
      <van-cell :value="userinfo.adr" title="年审结果" v-if="userinfo.auditStatus !== 0" clearable/>
      <van-cell title="年审纪录" v-if="userType === 2" @click="auditHistory">
        <template #default>
          <div>
            <div>查看</div>
          </div>
        </template>
      </van-cell>
     </van-cell-group>
    </div>
    <!-- <div v-if="mode">
      <div class="ht15"></div>
      <div class="ht15"></div>
      <div class="mt10 fsac" style="width: 100%">
        <van-button type="info" size="normal" color="#FDE415" round v-if="iAuditStatus === 1">
          <div class="hdBtnsb" style="font-weight: bold" v-if="iAuditStatus === 1">您当前账号正在审核中</div>
        </van-button>
        <van-button type="info" size="normal" color="#FDE415" round v-if="iAuditStatus === 3">
          <div class="hdBtnsb" style="font-weight: bold" v-if="iAuditStatus === 3">您的注册申请被驳回,请联系管理人员</div>
        </van-button>
      </div>
    </div> -->
    <!-- <div>
      <div class="syBotsection mt10">
        <van-field v-model="sCode" label="邀请码" />
        <van-field v-model="sName" label="姓名" />
]        <van-field v-model="sPhone" type="tel" label="手机号" />
        <van-field v-model="sAuthCode" center clearable label="短信验证码" placeholder="输入短信验证码">
          <template #button>
            <van-button size="small" type="primary" @click="getAuthCode" v-if="start <=0" :disabled="check(sPhone)">发送验证码</van-button>
            <van-button size="small" type="primary"  disabled v-else>发送验证码({{start}})</van-button>
          </template>
        </van-field>
        <van-field
          readonly
          clickable
          name="area"
          label="地区选择"
          placeholder="点击选择省市区"
          @click="showArea = true"
        />
        <van-field v-model="sProv" label="省" />
        <van-field v-model="sCity" label="市" />
        <van-field v-model="sDist" label="区" />
        <van-field v-model="sAddress" label="地址" />
        <van-popup v-model="showArea" position="bottom">
          <van-area
            :area-list="areaList"
            @confirm="onConfirmAdd"
            @cancel="showArea = false"
          />
        </van-popup>
      </div>
    </div> -->
    <div v-if="userinfo.auditStatus === 0">
      <div class="ht15"></div>
      <div class="mt10 fsac" style="width: 100%">
        <van-button type="info" size="normal" @click="submit" round>
          <div style="font-weight: bold; width: 70vw">去年审</div>
        </van-button>
      </div>
    </div>
    <!-- <div v-if="userinfo.selfAuditTimes + userinfo.">
      <div class="ht15"></div>
      <div class="mt10 fsac" style="width: 100%">
        <van-button type="info" size="normal" @click="submit" round>
          <div style="font-weight: bold; width: 70vw">去年审</div>
        </van-button>
      </div>
    </div> -->
  </div>
</template>

<script>
  import { Toast, Button, Uploader, Field, Cell, Area, Popup, SubmitBar, NavBar, CellGroup  } from 'vant'
  import axios from 'axios'
  // import wxu from '@/utils/wxu'
  // import Compressor from 'compressorjs'
  export default {
    components: {
      [Uploader.name]: Uploader,
      [Field.name]: Field,
      [Button.name]: Button,
      [Cell.name]: Cell,
      [Area.name]: Area,
      [Popup.name]: Popup,
      [SubmitBar.name]: SubmitBar,
      [NavBar.name]: NavBar,
      [CellGroup.name]: CellGroup 
    },
    async mounted() {
      await this.sbj()
      await this.cGet()
    },
    data() {
      return {
        fileList: [],
        audtiStatusMap: {
          // '-1': '全部',
          '0': '未年审',
          '1': '已年审'
        },
        auditStatus: '-1',
        auditResultMap: {
          // '-1': '全部',
          '0': ['未年审', 'rgba(254,82,83, 1)', 'rgba(254,82,83, 0.15)'],
          '1': ['年审通过', 'rgba(31,130,255, 1)', 'rgba(31,130,255, 0.15)'],
          '2': ['年审失败', 'rgba(224,42,42, 1)', 'rgba(224,42,42, 0.15)'],
          '3': ['失联', 'rgba(242,133,26)', 'rgba(242,133,26, 0.15)']
        },
        showArea: false,
        start: 0,
        userId: '',
        userType: '',
        userinfo: {

        }
      };
    },
    methods: {
      check (phone) {
        let t = /^[1][3-9][\d]{9}/
        return !t.test(this.sPhone)
      },
      async sbj () {
        let{userId, userType} = this.$route.query
        this.userId = userId
        this.userType = Number(userType)
        if (this.userType === 2 && !this.userId) {
          Toast('非法访问！')
          // this.$router.replace('/index')
        }
      },
      auditHistory () {
        this.$router.push({path: '/auditHistory', query: {userType: this.userType, userId: this.userId}})
      },
      onClickLeft () {
        this.$router.go(-1)
      },
      onConfirmAdd(s) {
        this.sProv = s[0].name
        this.sCity = s[1].name
        this.sDist = s[2].name
        this.showArea = false
      },
      goto(path) {
        this.$router.push(path)
      },
      async cGet() {
        let userId = this.$route.query.userId
        this.userId = userId
        let params = {}
        if (userId) {
          params.userId = userId
        }
        let { data, success, info } = await this.$api.ClientGet(params)
        if (success) {
          data.helpTypeName = data.helpTypeName.split(',')
          data.ssq = data.province + data.city + data.district
          data.ads = this.audtiStatusMap[data.auditStatus]
          data.adr = this.auditResultMap[data.auditResult][0]
          this.userinfo = data
          // let {name, phone, helpTypeName, idCard, address, auditResult, auditStatus, selfAuditTimes, } 
          console.log(data, 89898989)
          // this.mode = 'show'
        }
      },
      async submit() {
        let query = {
          userType: this.userType,
          userId: this.userId
        }
        this.$router.push({path: '/homeland', query})
      },
      showLoading(t = true, message = '请求中') {
        Toast.loading({
          message,
          forbidClick: true,
          overlay: t,
          duration: 0
        })
      }
    }
  };
</script>

<style>
  #subup .van-uploader__upload {
    width: 123px !important;
    height: 123px !important;
  }

  .sShopI {
    width: 123px !important;
    height: 123px !important;
    display: block;
  }

  .hdBtnsb {
    color: #111;
    width: 240px;
  }
  .logo {
    width: 125px;
    margin-left: 125px;
  }
  .logoimg {
    width: 125px;
  }
</style>